export const eKomiTheme = {
  palette: {
    primary: {
      light: "#47a123",
      main: "#2DA137",
      dark: "#47a123",
      contrastText: "#fff"
    },
    secondary: {
      light: "#47a123",
      main: "#2DA137",
      dark: "#47a123",
      contrastText: "#fff"
    }
  }
};
